import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { object, number } from 'yup';
import {
  Button,
  LoadingIndicator,
  CurrencyTextInput,
  Table,
} from '@components';
import { useNavigate } from 'react-router-dom';
import { Field, Formik } from 'formik';
import { TabelaContribuicaoService } from '@services';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { currency } from '@utils';

export const TabelaContribuicaoPage = () => {
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.user);
  const [resultCalculoContribuicao, setResultCalculoContribuicao] = useState(
    []
  );
  const [dadosIniciais, setDadosIniciais] = useState({
    remuneracao: '',
  });
  const navigate = useNavigate();

  const calcularContribuicao = (remuneracao) => {
    const service = new TabelaContribuicaoService();
    setLoading(true);

    service
      .calcularContribuicao(user.matricula, remuneracao, user.plano)
      .then((res) => {
        setResultCalculoContribuicao(res);
      })
      .catch(() => {
        toast.error('Erro ao obter dados');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return !loading ? (
    <>
      <Helmet>
        <title>Forluz - Calculadora de Contribuição</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Calculadora de Contribuição</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          <Formik
            initialValues={dadosIniciais}
            validationSchema={object({
              remuneracao: number().required('Insira o valor da remuneração'),
            })}
            onSubmit={(values) => {
              setDadosIniciais({
                remuneracao: values.remuneracao,
              });
              calcularContribuicao(values.remuneracao);
            }}
          >
            {({ handleSubmit, isSubmitting, isValid }) => (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <p className="ts-24 fw-bold">Calculadora</p>
                  <hr className=" mb-32 mt-2" />
                  <div className="col-12 col-md-4">
                    <Field
                      className="mb-3 mb-md-0"
                      name="remuneracao"
                      label="Remuneração mensal"
                      component={CurrencyTextInput}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="col-6">
                      <Button type="submit" disabled={isSubmitting || !isValid}>
                        Calcular
                      </Button>
                    </div>
                  </div>
                  <div className="col-12 col-md-6" />
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
      <br />
      <br />
      {resultCalculoContribuicao.length !== 0 && (
        <div className="card">
          <div className="card-body">
            <Table
              className="mb-5"
              columns={['Percentual', 'Cont. Pessoal', 'Cont. Patrocinadora']}
            >
              {resultCalculoContribuicao.map((item) => (
                <tr key={item.percentual}>
                  <td>{`${item.percentual}%`}</td>
                  <td>{currency(item.contriPessoal)}</td>
                  <td>{currency(item.contriPatrocinadora)}</td>
                </tr>
              ))}
            </Table>
          </div>
        </div>
      )}
    </>
  ) : (
    <LoadingIndicator />
  );
};
